import axiosClient from '../libs/axios';

// Gantt görevlerini getir
export const getGanttTasks = async (projectSlug) => {
  const response = await axiosClient.get(`/gantt/tasks/${projectSlug}`);
  return response.data;
};

// Yeni Gantt görevi oluştur
export const createGanttTask = async (projectSlug, taskData) => {
  const response = await axiosClient.post(`/gantt/tasks/${projectSlug}`, taskData);
  return response.data;
};

// Gantt görevini güncelle
export const updateGanttTask = async (taskId, taskData) => {
  const response = await axiosClient.put(`/gantt/tasks/${taskId}`, taskData);
  return response.data;
};

// Gantt görevini sil
export const deleteGanttTask = async (taskId) => {
  const response = await axiosClient.delete(`/gantt/tasks/${taskId}`);
  return response.data;
};

// Tek Gantt görevini getir
export const getGanttTask = async (taskId) => {
  const response = await axiosClient.get(`/gantt/tasks/single/${taskId}`);
  return response.data;
};

// Proje Gantt istatistiklerini getir
export const getGanttStatistics = async (projectSlug) => {
  const response = await axiosClient.get(`/gantt/statistics/${projectSlug}`);
  return response.data;
};

// Öncelik değerlerini API formatına çevir
export const mapPriorityToApi = (priority) => {
  const priorityMap = {
    'low': 1,
    'medium': 2,
    'high': 3
  };
  return priorityMap[priority] || 2;
};

// API'den gelen öncelik değerini frontend formatına çevir
export const mapPriorityFromApi = (priority) => {
  const priorityMap = {
    1: 'low',
    2: 'medium',
    3: 'high'
  };
  return priorityMap[priority] || 'medium';
};

// Görev verilerini API formatına çevir
export const formatTaskForApi = (taskData) => {
  return {
    task_name: taskData.name,
    description: taskData.description || '',
    start_date: taskData.startDate,
    end_date: taskData.endDate,
    progress: taskData.progress || 0,
    priority: mapPriorityToApi(taskData.priority),
    assigned_user_id: taskData.assignedUserId || null
  };
};

// API'den gelen görev verilerini frontend formatına çevir
export const formatTaskFromApi = (apiTask) => {
  return {
    id: apiTask.id,
    name: apiTask.task_name,
    description: apiTask.description || '',
    startDate: apiTask.start_date ? apiTask.start_date.split('T')[0] : '',
    endDate: apiTask.end_date ? apiTask.end_date.split('T')[0] : '',
    progress: apiTask.progress || 0,
    priority: mapPriorityFromApi(apiTask.priority),
    assignee: apiTask.assigned_user ? 
      `${apiTask.assigned_user.ufname} ${apiTask.assigned_user.ulname}` : '',
    assignedUserId: apiTask.assigned_user_id,
    status: getTaskStatus(apiTask.progress),
    creator: apiTask.creator ? 
      `${apiTask.creator.ufname} ${apiTask.creator.ulname}` : '',
    createdAt: apiTask.created_at,
    updatedAt: apiTask.updated_at
  };
};

// İlerleme yüzdesine göre durum belirle
const getTaskStatus = (progress) => {
  if (progress === 0) return 'pending';
  if (progress === 100) return 'completed';
  return 'in-progress';
};
